const BADGE_CLASSES = {
  sky: 'bg-sky-100 text-sky-800',
  amber: 'bg-amber-100 text-amber-800',
  emerald: 'bg-emerald-100 text-emerald-800',
} as const

/** Mała kolorowa etykieta rodzaju warunku (STATUS / DOK / POLE). */
export function Badge({ color, label }: { color: keyof typeof BADGE_CLASSES; label: string }) {
  return <span className={`rounded px-1.5 py-0.5 text-[10px] mr-2 ${BADGE_CLASSES[color]}`}>{label}</span>
}
